{
  const tracker = document.querySelector('script[data-homepage-product-path]');

  if (tracker) {
    const storageKey = 'fuel_07_browsing_history';
    const productPath = tracker.dataset.homepageProductPath;
    let history = [];

    try {
      const stored = JSON.parse(localStorage.getItem(storageKey) ?? '[]');
      if (Array.isArray(stored)) history = stored.filter((path) => typeof path === 'string');
    } catch (error) {
      history = [];
    }

    history = history.filter((path) => path !== productPath);
    history.push(productPath);

    try {
      localStorage.setItem(storageKey, JSON.stringify(history.slice(-20)));
    } catch (error) {
      // Browsing-history personalization is optional when storage is unavailable.
    }
  }
}
